import { SHARED_PAYMENT_KEY_MAPPING, createPaymentModeLabel } from "./shared";

/**
 * WEB variant — the ten shared entries plus web's own `bonushubedc`, in the same order the app
 * file had them (the extra key was last there too, and nothing iterates the map anyway).
 *
 * The `any` annotation is transcribed from both app files; call sites index it with an
 * arbitrary `mode` string.
 */
export const paymnetsKeyMapping: any = {
  ...SHARED_PAYMENT_KEY_MAPPING,
  bonushubedc: "BonusHub EDC",
  payu: "PayU",
};

/** The mapped display name, falling back to the raw mode when unmapped (web's table). */
export const getPaymentModeLabel = createPaymentModeLabel(paymnetsKeyMapping);
